import { render, staticRenderFns } from "./TipoCestaEditavel.vue?vue&type=template&id=072378c3"
import script from "./TipoCestaEditavel.vue?vue&type=script&lang=js"
export * from "./TipoCestaEditavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports